import { fetchEnv } from '../env';
import { handleError } from '../helpers/errorHelpers';
import loadAllPolyfills from './polyfills_chunk';

window.addEventListener('error', (event) => {
  console.error(event.message, event);
});

const loadApplication = () => {
  const loadMain = () =>
    import(/* webpackChunkName: "main_chunk" */ './main_chunk')
      .then((runMain) => runMain.default())
      .catch(handleError);

  loadMain();
};

fetchEnv().then(loadAllPolyfills).then(loadApplication).catch(handleError);

// Add support for HMR (Hot Module Replacement)
if (module.hot) {
  module.hot.accept();
}
